import styled from 'styled-components';
const ButtonGroupStyled = styled.div`
  height: 88px;
  margin-top: 0px;
  background-color: #fff;
  align-items: center;
  border-radius: 12px;
  padding: 24px 32px;
  /* margin-bottom: 24px; */
  .exit {
    margin-right: 16px;
  }
`;
export default ButtonGroupStyled;
